module.exports = __webpack_public_path__ + "static/media/contrast_img.e391ea12.jpg";